import auth from '@/shared/config/auth.config.js';
import api, { apiSuccessOutput } from '@/shared/config/api.js';

// Login with phone and password
export const loginPassword = async (phone_number, password) => {
  return auth.login(phone_number, password);
};

// Signup with phone and password
export const signupUser = async (phone_number, password, password_confirm) => {
  return auth.signup(phone_number, password, password_confirm);
};

// Verify OTP
export const verifyOTP = async (phone_number, otp) => {
  return auth.verifyOTP(phone_number, otp);
};

// Refresh token
export const refreshToken = async () => {
  return auth.refreshToken();
};

// Logout user
export const logoutUser = async () => {
  return auth.logout();
};

// Send OTP
export const sendOTP = async (phone_number) => {
  return auth.sendOTP(phone_number);
};

// Reset password
export const resetPassword = async (
  phone_number,
  otp,
  password,
  password_confirm,
) => {
  return auth.resetPassword(phone_number, otp, password, password_confirm);
};

// Change password
export const changePassword = async (
  old_password,
  new_password,
  new_password_confirm,
) => {
  return auth.changePassword(old_password, new_password, new_password_confirm);
};

// Get user details
export const getUserDetail = async () => {
  return apiSuccessOutput(
    await api.get('/tenant/v1/user', {
      showToast: false,
    }),
  );
};

// Update user profile
export const updateUserProfile = async (first_name, last_name, email) => {
  return apiSuccessOutput(
    await api.put('/tenant/v1/user', {
      first_name,
      last_name,
      email,
    }),
  );
};

export default {
  loginPassword,
  signupUser,
  verifyOTP,
  refreshToken,
  logoutUser,
  sendOTP,
  resetPassword,
  changePassword,
  getUserDetail,
  updateUserProfile,
};
